module.exports = __webpack_public_path__ + "static/media/chat.b4dc0b1b.svg";